var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-from-top"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px"}},[_c('ProductTree'),_c('DirectAccess')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }